__turbopack_context__.v({
  "CarousalWrapper": "AccreditionsRecognitions-module-scss-module__Mhjdnq__CarousalWrapper",
  "hr": "AccreditionsRecognitions-module-scss-module__Mhjdnq__hr",
  "item": "AccreditionsRecognitions-module-scss-module__Mhjdnq__item",
  "svgContainer": "AccreditionsRecognitions-module-scss-module__Mhjdnq__svgContainer",
});
